// Main entry point for shared dives components
import SharedDivesSection from "./SharedDivesSection";
import UserSharedDives from "./UserSharedDives";
import UserRelatedDives from "./UserRelatedDives";
import UserNonSharedDives from "./UserNonSharedDives";
import SharedDiveCard from "./cards/SharedDiveCard";
import NonSharedDiveCard from "./cards/NonSharedDiveCard";
import RelatedDiveCard from "./cards/RelatedDiveCard";
import SharedDiveDetailsDialog from "./dialogs/SharedDiveDetailsDialog";
import RelatedDiveGroupDialog from "./dialogs/RelatedDiveGroupDialog";

// Export the main component as default
export default SharedDivesSection;

// Export all components individually
export {
  SharedDivesSection,
  UserSharedDives,
  UserRelatedDives,
  UserNonSharedDives,
  SharedDiveCard,
  NonSharedDiveCard,
  RelatedDiveCard,
  SharedDiveDetailsDialog,
  RelatedDiveGroupDialog,
};
